import axios from 'axios'
import { getSession, getCookie, } from "./cookie"
import { Message, Loading } from 'element-ui'

const service = axios.create({
  // baseURL: "/admin",
  baseURL: process.env.NODE_ENV === 'production' ? 'https://erp.zuizhenshi.cn' : '/admin',
  timeout: 600000, // request timeout
})
let loading = null;
service.interceptors.request.use(
  config => {
    if (config.method !== 'get') {

      loading = Loading.service({
        lock: true,
        text: '请求数据中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.7)'
      });
    }
    config.headers['Content-Type'] = 'application/json';

    let sessionId = getSession()
    if (sessionId) {
      config.headers['X-Token'] = sessionId;
    }
    return config
  },
  error => {
    if (loading !== null) {
      loading.close();
    }
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response
    if (loading !== null) {
      loading.close();
    }
    // if (res.data.code == 0) {
    //   Message({
    //     message: res.data.data.msg,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   return Promise.reject(res.data.data.msg)
    // }
    return res.data
  },
  error => {

    if (error.response) {
      Message({
        message: error.response.data.error.code || error.response.data.error.message,
        type: 'error',
        duration: 5 * 1000
      })
      if (loading !== null) {
        loading.close();
      }
      return Promise.reject(error)
    }

  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/requestJson.js